import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import CelebrationBomb from "./CelebrationBomb";
import "./css/quizCompleted.css";

/**
 * Pantalla de "quiz completado" reutilizable.
 * Muestra celebración + botón "Continuar" que navega al siguiente módulo.
 *
 * @param {string} celebracion - Mensaje del CelebrationBomb.
 * @param {string} titulo - Título grande (ej: "¡Quiz completado!").
 * @param {string} subtitulo - Texto secundario.
 * @param {string} botonTexto - Texto del botón (default: "Continuar").
 * @param {string} rutaSiguiente - Ruta a la que navega el botón.
 * @param {string} [iconoBoton] - Icono del botón.
 */
const QuizContinueCard = ({
  celebracion = null,
  titulo = "¡Bien hecho!",
  subtitulo = "Continúa con el siguiente paso.",
  botonTexto = "Continuar",
  rutaSiguiente,
  iconoBoton = "mdi:arrow-right-circle",
}) => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowButton(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="quiz-completed-wrapper">
      <CelebrationBomb
        message={celebracion}
        intensity={120}
        duration={4}
        size="lg"
      />

      <motion.div
        className="quiz-completed-card"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="quiz-completed-icon-wrapper"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.4, type: "spring" }}
        >
          <Icon icon="ph:check-bold" />
        </motion.div>

        <motion.h2
          className="quiz-completed-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          {titulo}
        </motion.h2>

        <motion.p
          className="quiz-completed-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
        >
          {subtitulo}
        </motion.p>

        {showButton && rutaSiguiente && (
          <motion.button
            className="quiz-completed-btn"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1 }}
            onClick={() => navigate(rutaSiguiente)}
          >
            <Icon icon={iconoBoton} />
            <span>{botonTexto}</span>
          </motion.button>
        )}
      </motion.div>
    </div>
  );
};

export default QuizContinueCard;
